import { Button } from "antd";
import { Link } from "react-router-dom";
import { styled } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 0;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`;

export const StyledLink = styled(Link)`
  text-align: center;
  display: block;
  font-size: 40px;
  font-weight: 800;
  margin: 20px 0;
  color: #225F9B;
  text-decoration: none;


  &:hover {
    cursor: pointer;
  }
`;

export const SignUpTitle = styled.div`
  padding: 20px 0;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
`;

export const CustomSteps = styled.div<{ current: number }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 600px;
  background-color: #d9d9d9;
  border-radius: 30px;
  margin-bottom: 20px;
`;

export const CustomStep = styled.div<{ isActive: boolean }>`
  flex-grow: 1;
  text-align: center;
  padding: 10px 0;
  background-color: ${({ isActive }) => (isActive ? '#225F9B' : '#D9D9D9')};
  color: white;
  border-radius: 30px;
`;

export const StepsContent = styled.div`
  margin-top: 16px;
  padding: 30px;
  border: 1px solid #e9e9e9;
  border-radius: 2px;
  width: 600px;
`;

export const StepsAction = styled.div<{ hasPrevButton: boolean; hasSingleButton: boolean }>`
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: ${({ hasPrevButton }) => (hasPrevButton ? 'space-between' : 'flex-end')};
`;

export const CustomButton = styled(Button)`
  border-radius: 4px;
  background-color: white;
  color: black;
  border: 1px solid #ccc;

  span {
    padding: 0 20px;
  }

  &:hover {
    background-color: #225f9b;
    border-color: white;
    border: 1px solid #ccc;
  }
`;